import { SVGProps, Ref, forwardRef } from 'react';

export const SpeakerCrossOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.812 2.233c-.522-.555-1.255-.067-2.722.91l-.846.562q-.975.645-1.945 1.297L3 5C.375 5 0 5.375 0 8s.375 3 3 3q.155 0 .3-.002.97.651 1.944 1.297l.002.001.844.561c1.467.977 2.2 1.465 2.722.91.521-.556.521-1.825.521-4.364V6.597c0-2.539 0-3.808-.521-4.364m-5.094 7.36.363.244c.642.432 1.284.858 1.93 1.287l.004.003q.424.28.85.565a34 34 0 0 0 .995.645q.008-.064.014-.137c.058-.624.06-1.498.06-2.797V6.597c0-1.299-.002-2.173-.06-2.796l-.014-.138-.065.04c-.258.158-.556.357-.93.605l-.85.566c-.648.43-1.291.857-1.934 1.29l-.363.244-.437-.006L3 6.4c-.646 0-1.05.025-1.317.075-.08.015-.133.03-.167.041a1 1 0 0 0-.04.167C1.425 6.95 1.4 7.354 1.4 8s.025 1.05.075 1.317q.023.118.041.167c.034.01.087.026.167.04.267.05.671.076 1.317.076q.147 0 .28-.002zm-2.184-.064.002.004z"
                fill="currentColor"
            />
            <path
                d="M11.01 9.505 12.515 8 11.01 6.495l.99-.99 1.505 1.505 1.505-1.505.99.99L14.495 8 16 9.505l-.99.99-1.505-1.505L12 10.495z"
                fill="currentColor"
            />
        </g>
    </svg>
));
SpeakerCrossOutlinedSize16Glyph.displayName = 'SpeakerCrossOutlinedSize16Glyph';
